import React, { useEffect, useState } from "react";
import { Sidebar } from "primereact/sidebar";
import { Button } from "primereact/button";
import { Link } from "react-router-dom";
import { useHistory } from "react-router-dom";
type Props = {
    onAccept: () => void;
};

const CookieConsent = (props: Props) => {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        if (window.localStorage.getItem("cookieconsent") === "true") {
            setVisible(false);
            props.onAccept();
        } else {
            setVisible(true);
        }
    }, []);
    const history = useHistory();
    return (
        <Sidebar
            visible={visible}
            onHide={() => setVisible(false)}
            position="bottom"
            dismissable={false}
            modal={true}
            blockScroll={true}
            showCloseIcon={false}
        >
            <div className="cookie-consent">
                <p>
                    Diese Website benötigt Cookies, um die Funktionalität zu
                    gewährleisten.
                    <Link to="/datenschutz">Mehr erfahren</Link>
                </p>
                <div className="cookie-actions">
                    <Button
                        label="Ablehenen und Zurück"
                        onClick={() => history.goBack()}
                        className="p-button-text p-button-plain"
                    />
                    <Button
                        label="Akzeptieren"
                        onClick={() => {
                            props.onAccept();
                            setVisible(false);
                        }}
                    />
                </div>
            </div>
        </Sidebar>
    );
};

export default CookieConsent;
